// export const SET_SINGER = 'SET_SINGER'
export const SET_USERID = 'SET_USERID'
export const SET_COURSEID = 'SET_COURSEID'
export const SET_STUDY_EXPERIENCE = 'SET_STUDY_EXPERIENCE'
export const SET_GROWTH_EXPERIENCE = 'SET_GROWTH_EXPERIENCE'
export const SET_WORK_EXPERIENCE = 'SET_WORK_EXPERIENCE'
export const SET_USER = 'SET_USER'
export const SET_LAYOUT_COURSE = 'SET_LAYOUT_COURSE'
export const SET_RECOMMEND_COURSE = 'SET_RECOMMEND_COURSE'
export const SET_CURRENTDATA = 'SET_CURRENTDATA'
export const SET_SEARCHMARK = 'SET_SEARCHMARK'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js